<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    props: {
        duration: {
            type: Number,
            default: 0.25,
        },
        initialHeight: {
            type: Number,
            default: 0,
        },
    },
    emits: ["heightChanged"],
    data: () => ({
        resizeObserver: null as ResizeObserver | null,
        currentHeight: 0,
        mountedOnce: false,
    }),
    mounted() {
        const wrapper = this.$refs.wrapper as HTMLDivElement;
        const content = this.$refs.content as HTMLDivElement;

        wrapper.style.transitionDuration = `${this.duration}s`;

        const targetHeight = content.scrollHeight;

        this.currentHeight = this.initialHeight;
        wrapper.style.height = `${this.initialHeight}px`;

        requestAnimationFrame(() => {
            wrapper.style.height = `${targetHeight}px`;
            this.currentHeight = targetHeight;
            this.mountedOnce = true;
        });

        this.resizeObserver = new ResizeObserver(() => {
            this.animateToContentHeight();
        });

        this.resizeObserver.observe(content);
    },
    beforeUnmount() {
        this.resizeObserver?.disconnect();
    },
    computed: {},
    methods: {
        async animateToContentHeight() {
            await this.$nextTick();

            const wrapper = this.$refs.wrapper as HTMLDivElement;
            const content = this.$refs.content as HTMLDivElement;

            const newHeight = content.offsetHeight;

            if (newHeight === this.currentHeight) return;

            wrapper.style.height = `${this.currentHeight}px`;

            requestAnimationFrame(() => {
                wrapper.style.height = `${newHeight}px`;
                this.currentHeight = newHeight;
            });
        },
    },
});
</script>

<template>
    <div ref="wrapper" class="transition-height" @transitionend.self="$emit('heightChanged')">
        <div ref="content" class="transition-height-content">
            <slot></slot>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.transition-height {
    width: 100%;
    overflow: hidden;
    transition-property: height;
    transition-timing-function: ease;

    .transition-height-content {
        width: 100%;
    }
}
</style>
